import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col flex-auto flex-shrink-0 antialiased bg-Active text-black dark:text-white" }
const _hoisted_2 = { class: "fixed flex items-center justify-between h-14 text-white z-10 right-0" }
const _hoisted_3 = { class: "flex justify-between items-center h-14 header-right pt-4 pr-4" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "block h-6 mx-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "block w-px h-6 mx-3" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex mr-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-5 h-5",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    })
  ])
], -1)
const _hoisted_8 = { class: "h-full ml-14 mt-14 mb-10 md:ml-64" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Dashboard = _resolveComponent("Dashboard")!
  const _component_PurchaseView = _resolveComponent("PurchaseView")!

  return (_openBlock(), _createElementBlock("div", {
    "x-data": "setup()",
    class: _normalizeClass({ dark: _ctx.isDark })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_5, "Hello, " + _toDisplayString(_ctx.username), 1)
            ]),
            _hoisted_6,
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                class: "flex items-center mr-4 hover:text-blue-100 cursor-pointer"
              }, [
                _hoisted_7,
                _createTextVNode(" Logout ")
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Sidebar, { isDashboard: _ctx.isDashboard }, null, 8, ["isDashboard"]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.$route.path === '/dashboard' || _ctx.$route.path === '/dashboard/')
          ? (_openBlock(), _createBlock(_component_Dashboard, {
              key: 0,
              username: _ctx.username,
              discord_avatarid: _ctx.discord_avatarid,
              discord_id: _ctx.discord_id,
              discord_linked: _ctx.discord_linked,
              discord_username: _ctx.discord_username,
              email: _ctx.email,
              loading: _ctx.loading,
              onetap_username: _ctx.onetap_username,
              solarus_uid: _ctx.solarus_uid,
              onetap_uid: _ctx.onetap_uid,
              created_at: _ctx.created_at,
              subscription_value: _ctx.subscription_value,
              onHandlePurchaseButton: _ctx.handlePurchaseButton
            }, null, 8, ["username", "discord_avatarid", "discord_id", "discord_linked", "discord_username", "email", "loading", "onetap_username", "solarus_uid", "onetap_uid", "created_at", "subscription_value", "onHandlePurchaseButton"]))
          : _createCommentVNode("", true),
        (_ctx.$route.path === '/dashboard/purchase')
          ? (_openBlock(), _createBlock(_component_PurchaseView, { key: 1 }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}